import SBMessageInputWrapper from '@sendbird/uikit-react/GroupChannel/components/MessageInputWrapper';
import { useGroupChannelContext } from '@sendbird/uikit-react/GroupChannel/context';
import { YStack } from 'smoothie';

import { useLocalMessageDrafts } from '../hooks/useLocalMessageDrafts';
import { DraftFromTemplate } from './MessagingTools/MessageTemplates';

export const MessageInputWrapper = ({
    channelUrl,
    initialMessage,
    onMessageChange,
}: {
    channelUrl: string;
    initialMessage: string;
    onMessageChange: (msg: string) => void;
}) => {
    const { messageInputRef, currentChannel } = useGroupChannelContext();
    useLocalMessageDrafts(
        channelUrl,
        messageInputRef,
        initialMessage,
        onMessageChange,
    );

    return (
        <YStack width="100%">
            <SBMessageInputWrapper />
            <DraftFromTemplate
                messageInputRef={messageInputRef}
                currentChannel={currentChannel}
            />
        </YStack>
    );
};
